<template>
    <div class="auth-form">
        <div class="auth-form__wrap">
            <div class="text-center">
                <svg class="big-icon" style="width: 47px; height: 48px; ">
                    <use xlink:href="@/assets/img/big-icons-sprite.svg#lock2"></use>
                </svg>
            </div>

			<div class="text-size-xxl text-bold text-center mt32 montserrat" v-if="isTeam" style="line-height: 39px;">
				{{teamUserName}},<br>
				здравствуйте!
			</div>
			<div class="text-center mt20 montserrat" v-if="isTeam">
				Пожалуйста, подтвердите, что это именно вы.<br>
				Для этого укажите свой номер телефона.
			</div>

            <div class="row-b mt32">
                <div class="row-b__col elem-pos-fit">
                    <input-styled
                                  v-model="login"
                                  :placeholder="'Номер телефона'"
                                  :disabled="formAuthFields.login.disabled"
                                  :isEdit="formAuthFields.login.disabled && step === 2"
                                  @edit="edit"
                                  name="login"
                                  :placeholderInput="'Номер телефона'"
                                  :is-block-arrow-phone="true"
                                  :is-clear-btn="login.length > 1"
                                  @enter="enter(formAuthFields.login.name)"
                                  :mask="{mask:'+7(999)999-99-99',showMaskOnHover: false}"
                                  :isError="formAuthFields.login.error"
                                  @focus="removeError(formAuthFields.login.name)"
                                  @input="removeError(formAuthFields.login.name)"
                                  ref="loginInput"
                                  class="montserrat"
                    ></input-styled>
                </div>

                <!-- <div class="text-color-grey text-size-s" :class="{error:formAuthFields.login.error}">Допускаются только мобильные номера<br>российских операторов</div> -->
            </div>


            <div class="row-b mt32" v-if="step === 2">
                <div class="row-b__col elem-pos-fit">
                    <input-styled v-model="password"
                                  name="password"
                                  :placeholder="'Код из СМС'"
                                  :placeholderInput="'Код из СМС'"
                                  :isError="formAuthFields.password.error"
                                  :errorText="formAuthFields.password.errorText"
                                  @focus="removeError(formAuthFields.password.name)"
                                  @enter="enter(formAuthFields.password.name)"
                                  @input="removeError(formAuthFields.password.name)"
                                  ref="passwordInput"
                                  :isClearBtn="true"
                                  class="montserrat"
                    ></input-styled>
                </div>
            </div>

            <div class="mt4" v-if="step === 2">
                <div class="row-b__col elem-pos-fit text-center">
                    <div class="text-color-grey text-size-s montserrat" v-if="timer.smsBan && !formAuthFields.password.error">Новый код отправлен на указанный номер.<br>Повторный запрос возможен через {{ timer.timeBan }} ч.</div>
                    <div class="text-size-s"
                         @click="newPassword"
                         v-else-if="timer.time === 0 && !formAuthFields.password.error"><span class="link-color hover montserrat">Запросить новый</span></div>
                    <div class="text-color-grey text-size-s montserrat" v-else-if="!formAuthFields.password.error">Запросить новый через {{ timer.time }} сек.</div>
                </div>
            </div>


            <div class="mt32 text-center auth-btn">
                <submit-btn tag="button"
                            class="montserrat"
                            @click.native="authorize" :type="button">
                    Продолжить
                </submit-btn>
            </div>
        </div>
    </div>
</template>

<script>
    import InputStyled from '@/components/forms/InputStyled.vue'
    import { mapState } from 'vuex'
    import SubmitBtn from '@/components/forms/SubmitBtn.vue'

    export default {
        name: "Auth",
        props: {
            typeLk: {
                default: 'user'
            },
			isTeam: {
				default(){
					return false;
				}
			}
        },
        components: {
            InputStyled,
            SubmitBtn
        },
        data: function(){
            return {
                button: 'normal',
                isTeamParam: this.isTeam,
                teamUserName: '',
            }
        },
        computed: {
            login: {
                get () {
                    return this.formAuthFields.login.value
                },
                set (value) {
                    this.$store.commit('auth/setFormAuthField', {
                        name: this.formAuthFields.login.name,
                        value:value,
                    })
                }
            },
            password: {
                get () {
                    return this.formAuthFields.password.value
                },
                set (value) {
                    this.$store.commit('auth/setFormAuthField', {
                        name: this.formAuthFields.password.name,
                        value:value,
                    })
                }
            },
            ...mapState({
                popups: state => state.popups.items,
                formAuthFields: state => state.auth.forms.auth.fields,
                timer: state => state.auth.forms.auth.timer,
                step: state => state.auth.forms.auth.step,
                isRedirect: state => state.auth.isRedirect,
            }),
        },
        mounted() {
            this.$router.onReady(() => {
                if(this.$route.name=='user-contract' && this.$route.params.uid){
                    this.$store.dispatch('usercontract/getUseName',this.$route.params.uid).then(response => { 
                        this.teamUserName = response.name; 
                    });     
                }
            });
            let self = this;
            setTimeout(function () {
                self.inputFocus('loginInput')
            },500);
        },
        watch: {
          'formAuthFields.password.error'(val, oldVal){
              if(val){
                  this.button = 'normal';
              }
          }
      },
        methods: {
            edit () {
                this.$store.commit('auth/setFormAuthDisabled',{
                    name: this.formAuthFields.login.name,
                    value: false
                });
                this.$store.commit('auth/setStep',{ step:1 })
                this.$nextTick(function () {
                    this.inputFocus('loginInput')
                })
            },
            enter (field) {
                this.removeError(field);
                this.authorize()
            },
            newPassword () {
                this.$store.commit('auth/setFormAuthField', {
                    name: this.formAuthFields.password.name,
                    value: '',
                });
                this.$store.dispatch('auth/checkLogin',{ resend:true,isTeam: this.isTeam ? 'Y':'N' });
                this.inputFocus('passwordInput')
            },
            authorize () {
                let self = this;
                switch (this.step) {
                    case 1:
                        if(!this.checkLogin()){
                            return false
                        }
                        this.$store.commit('auth/setFormAuthDisabled',{
                            name: this.formAuthFields.login.name,
                            value: true
                        });

                        this.$store.dispatch('auth/checkLogin',{ resend:false, isPartner: this.typeLk === 'partner', isLK: this.typeLk !== 'partner',isTeam: this.isTeam ? 'Y':'N'}).then(function () {
                            self.$store.commit('auth/setStep',{ step:2 });
                            self.$nextTick(function () {
                                self.inputFocus('passwordInput')
                            });
                        });
                        break;
                    case 2:
                        if(!this.formAuthFields.password){
                            this.button = 'load';
                        }
                        if(!this.checkLogin() || !this.checkPassword()){
                            return false
                        }
                        this.$store.dispatch('auth/getToken',{isOrder:false,isTeam: this.isTeam ? 'Y':'N'}).then(() => {
                            this.button = 'ok';
                            this.$store.dispatch('rules/getMarks');
                        });

                        break;
                }
            },
            inputFocus(ref) {
                if(!!this.$refs[ref]){
                    this.$refs[ref].$el.getElementsByClassName('inp-s')[0].focus()
                }
            },
            checkLogin () {
                let phone = this.formAuthFields.login.value.replace(/[^\+0-9]/g, '');
                if(phone.length < 12 || phone[2] !== '9') {
                    this.$store.commit('auth/setFormAuthError',{
                        name: this.formAuthFields.login.name,
                        value: true
                    });
                    return false;
                }
                return true;
            },
            checkPassword () {
                if(this.formAuthFields.password.value.length < 4 ) {
                    this.$store.commit('auth/setFormAuthError',{
                        name: this.formAuthFields.password.name,
                        value: true
                    });
                    return false;
                }
                return true;
            },
            removeError (field) {
                this.$store.commit('auth/setFormAuthError',{ name: field, value: false })
            },
        }
    }
</script>

<style>

</style>
